import ExpandImage from "@/icons/components/ExpandImage";
import styles from "./styles.module.css";
import Image from "@/shared/components/Image/new";
import { getImageFromClippingList } from "@/shared/functions/getImagesFunctions";


const Img = ({ image, paragraph }) => {
  const { _id, dimensions } = image;
  const { value, epigraphe } = paragraph;

    
  const DESKTOP_CROP_ID = '3_2_870x580';
  const TABLET_CROP_ID = '3_2_630x420';
  const MOBILE_CROP_ID = '3_2_300x200';

  const mainImageObject = getImageFromClippingList(value.clippings, DESKTOP_CROP_ID);
  const mainImageUrl = mainImageObject ? (mainImageObject.domain + mainImageObject.imgUrl) : '';
  const imageTitle = value.title || epigraphe;

  const element = {
    images: [
      value &&
      {
        clippings: value.clippings || [],
        title: value.title || ""
      }
    ]
  }

  return (
    <div className={styles['article-image-epi']}>
      <Image
        element={element}
        width={dimensions && dimensions.width}
        height={dimensions && dimensions.height}
        className={styles['cover-image']}
        src={mainImageUrl}
        alt={imageTitle}
        clipping={DESKTOP_CROP_ID}
        srcSet={{
            desktop: DESKTOP_CROP_ID,
            tablet: TABLET_CROP_ID,
            mobile: MOBILE_CROP_ID
        }}
      />
      <span className={styles["epigraphe"]}>{epigraphe}</span>
      <hr />
      <span className={styles["img-expand"]}>
        <button className={styles["open-img"]} aria-label="Open Image">
          <ExpandImage />
        </button>
      </span>
    </div>
  );
}

export default Img;